<app-wrapper>
  <div class="mb-9">
    <div class="mb-4">
      <div class="row g-3">
        <div class="col-auto">
          <h2>
            <div class="d-inline pe-2 cursor-pointer" (click)="back()" title="Назад">
              <i class="fa-solid fa-arrow-left"></i>
            </div>
            Магазин
          </h2>
        </div>
      </div>
    </div>
    <div class="row g-5">
      <div class="col-12">
        <ul ngbNav #nav="ngbNav" class="nav-tabs">
          <li ngbNavItem>
            <button ngbNavLink>Основная информация</button>
            <ng-template ngbNavContent>
              <app-store-main-info [storeId]="storeId"></app-store-main-info>
            </ng-template>
          </li>
          <li ngbNavItem>
            <button ngbNavLink>Замена продуктов</button>
            <ng-template ngbNavContent>
              <app-store-product-replacement [storeId]="storeId"></app-store-product-replacement>
            </ng-template>
          </li>
        </ul>
        <div [ngbNavOutlet]="nav" class="mt-2"></div>
      </div>
    </div>
  </div>
</app-wrapper>